var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsuarios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 20,
    height: 20,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M10 0C7.23857117 0 5 2.23858643 5 5s2.23857117 5 5 5 5-2.23858643 5-5-2.23857117-5-5-5zm2.625 5c0-1.44973755-1.1752472-2.625-2.625-2.625S7.375 3.55026245 7.375 5 8.5502472 7.625 10 7.625 12.625 6.44973755 12.625 5zM0 16.25c0-3.3250122 6.66299438-5 10-5 3.33700562 0 10 1.6749878 10 5V20H0v-3.75zm17.625 0c0-.7999878-3.91299438-2.625-7.625-2.625s-7.625 1.8250122-7.625 2.625v1.375h15.25V16.25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarios);
export default __webpack_public_path__ + "static/media/usuarios.4515c90b8b1dee1798c0804470b3cafa.svg";
export { ForwardRef as ReactComponent };